import { IconContext } from 'phosphor-react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { theme } from '../mui-theme';
import { colors } from '../shared-components/styles';
import { useWeglot } from './language-weglot/useWeglot';
import { StoreProvider } from './store-provider/provider';
import { ViewerRenderer } from './ViewerRenderer';
import { ThemeProvider, StyledEngineProvider } from '@mui/material';

export const App = () => {
  // Initialize the query client for react-query.
  const client = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
      },
    },
  });

  // Initialize weglot for language support.
  useWeglot();

  // Set defaults for all phosphor icons.
  const phosphorTheme = {
    color: colors.black,
    size: 32,
    weight: 'regular',
    mirrored: false,
  };

  return (
    <QueryClientProvider client={client}>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <IconContext.Provider value={phosphorTheme}>
            <StoreProvider>
              <ViewerRenderer />
            </StoreProvider>
          </IconContext.Provider>
        </ThemeProvider>
      </StyledEngineProvider>
    </QueryClientProvider>
  );
};
